module.exports = __webpack_public_path__ + "client-icon.png?89ff5cdaca3b196e6cbbf9f157edf584";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/client-icon.png
// module id = 195
// module chunks = 0